import styled from '@emotion/styled'
import { TextArea } from 'components/deprecated/Inputs'
import { Button } from 'components/patterns'

export const StyledSaveNoteButton = styled(Button)`
  display: flex;
  align-items: center;
  font-size: 12px !important;
  height: 24px !important;
  margin: 0px !important;
`

export const StyledTextArea = styled(TextArea)`
  & textarea {
    min-height: 32px !important;
    line-height: 26px !important;
  }
`
